import { jwtDecode } from "jwt-decode";
import { AppSettings } from "../constants/AppSettings";
import { GetAccessTokenPayload } from "../services/AuthService";
import { AccessTokenPayload } from "../models/AccessTokenPayload";
import Localization from "sap/base/i18n/Localization";

// Language is stored in the Users DB table. When user logs in, the language is available in the access token payload.
export function GetCurrentLanguage(): string {
  // Localization.getLanguageTag().language; // get current ui5 app language
  const accessTokenDecoded = GetAccessTokenPayload();
  return accessTokenDecoded?.language || AppSettings.defaultLanguage;
}

export function UpdateLanguageFromAccessToken(
  accessToken: string,
  suppressReload = false
) {
  const accessTokenDecoded = jwtDecode<AccessTokenPayload>(accessToken);
  if (
    accessTokenDecoded.language &&
    Localization.getLanguage() != accessTokenDecoded.language
  ) {
    Localization.setLanguage(accessTokenDecoded.language);
    if (!suppressReload) {
      location.reload(); // refresh page to update translations which are configured as "formatter: '.translate'", e.g. dashboard tiles
    }
  }
}

export function GetAvailableLanguages() {
  return AppSettings.languages;
}
